// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.membership-container {
  text-align: center;
  padding: 2rem;
  font-family: Arial, sans-serif;
}

.membership-subtitle {
  color: #666;
  margin-bottom: 2rem;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.plan-card {
  background: #fafafa;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.plan-card button {
  margin-top: 1rem;
  background: #007bff;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
}

.one-time-payment {
  color: #28a745;
  font-weight: bold;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

/* ── Share / copy link button ── */
.share-link-btn {
  display: block;
  width: 100%;
  margin-top: 0.5rem !important;
  background: transparent !important;
  color: #555 !important;
  border: 1px dashed #bbb !important;
  border-radius: 8px !important;
  padding: 0.45rem 1rem !important;
  font-size: 13px !important;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.share-link-btn:hover {
  border-color: #007bff !important;
  color: #007bff !important;
}

.membership-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.membership-form {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 420px;
  text-align: center;
  max-height: 90vh;
  overflow-y: auto;
}

.membership-price {
  color: #28a745;
  font-weight: bold;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.form-group {
  margin-bottom: 15px;
  text-align: left;
}

.membership-form input,
.membership-form select {
  width: 100%;
  padding: 0.7rem;
  margin: 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 15px;
  box-sizing: border-box;
}

.membership-form input.error,
.membership-form select.error {
  border: 2px solid #ff4444;
}

.error-message {
  color: #ff4444;
  font-size: 12px;
  display: block;
  margin-top: 5px;
}

.membership-form button {
  width: 100%;
  padding: 0.8rem;
  margin-top: 1rem;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
}

.membership-form button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.cancel-btn {
  background: #dc3545 !important;
  margin-top: 0.6rem;
}

/* Stripe card element */
.stripe-card-element-wrapper {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px 14px;
  background: #fff;
  box-sizing: border-box;
  margin-top: 4px;
  transition: border-color 0.2s;
}

.stripe-card-element-wrapper:focus-within {
  border-color: #007bff;
}

/* Stripe security note */
.secure-note {
  font-size: 12px;
  color: #555;
  background: #f0fff4;
  border: 1px solid #c3e6cb;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 1rem;
  text-align: left;
}

/* ── Sections ── */
.membership-section {
  margin-bottom: 3rem;
}

.section-badge {
  display: inline-block;
  background: #007bff;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 4px 14px;
  border-radius: 20px;
  margin-bottom: 0.75rem;
  letter-spacing: 0.05em;
}

.welfare-badge {
  background: #00703C;
}

.section-divider {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 2rem 0;
  color: #aaa;
  font-size: 0.9rem;
}

.section-divider::before,
.section-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #e0e0e0;
}

/* ── Plan cards ── */
.membership-plan-card {
  border-top: 4px solid #007bff;
}

.welfare-plan-card {
  border-top: 4px solid #00703C;
}

.plan-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

/* ── Welfare options ── */
.welfare-payment-options {
  background: #f0f7f0;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin: 1rem 0;
  text-align: left;
}

.welfare-options-label {
  font-size: 12px;
  font-weight: bold;
  color: #555;
  margin: 0 0 0.5rem;
}

.welfare-options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 8px;
  font-size: 13px;
  color: #444;
}

.welfare-join-btn {
  margin-top: 1rem;
  background: #00703C;
  color: white;
  border: none;
  padding: 0.65rem 1.4rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  width: 100%;
  transition: background 0.2s;
}

.welfare-join-btn:hover { background: #005a30; }

.outline-btn {
  background: transparent !important;
  border: 2px solid #00703C !important;
  color: #00703C !important;
}

.outline-btn:hover {
  background: #00703C !important;
  color: #fff !important;
}

.welfare-cta { margin-top: 0.5rem; }

.welfare-login-note {
  font-size: 13px;
  color: #888;
  margin-bottom: 0.5rem;
}

.welfare-locked-note {
  font-size: 13px;
  color: #856404;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 0.5rem;
  text-align: left;
}

.already-member-note {
  font-size: 13px;
  color: #28a745;
  margin-top: 0.75rem;
}

.link-text {
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
}

.link-text:hover { color: #0056b3; }`, "",{"version":3,"sources":["webpack://./src/pages/Membership.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,sBAAsB;EACtB,kCAAkC;EAClC,6BAA6B;EAC7B,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,2BAA2B;AAC7B;;AAEA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,eAAe,kBAAkB,EAAE;;AAEnC;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA,mBAAmB,cAAc,EAAE","sourcesContent":[".membership-container {\n  text-align: center;\n  padding: 2rem;\n  font-family: Arial, sans-serif;\n}\n\n.membership-subtitle {\n  color: #666;\n  margin-bottom: 2rem;\n}\n\n.plans-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.plan-card {\n  background: #fafafa;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.plan-card button {\n  margin-top: 1rem;\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.one-time-payment {\n  color: #28a745;\n  font-weight: bold;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n}\n\n/* ── Share / copy link button ── */\n.share-link-btn {\n  display: block;\n  width: 100%;\n  margin-top: 0.5rem !important;\n  background: transparent !important;\n  color: #555 !important;\n  border: 1px dashed #bbb !important;\n  border-radius: 8px !important;\n  padding: 0.45rem 1rem !important;\n  font-size: 13px !important;\n  cursor: pointer;\n  transition: border-color 0.2s, color 0.2s;\n}\n\n.share-link-btn:hover {\n  border-color: #007bff !important;\n  color: #007bff !important;\n}\n\n.membership-form-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.membership-form {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 420px;\n  text-align: center;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.membership-price {\n  color: #28a745;\n  font-weight: bold;\n  font-size: 1.2rem;\n  margin-bottom: 1rem;\n}\n\n.form-group {\n  margin-bottom: 15px;\n  text-align: left;\n}\n\n.membership-form input,\n.membership-form select {\n  width: 100%;\n  padding: 0.7rem;\n  margin: 0;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 15px;\n  box-sizing: border-box;\n}\n\n.membership-form input.error,\n.membership-form select.error {\n  border: 2px solid #ff4444;\n}\n\n.error-message {\n  color: #ff4444;\n  font-size: 12px;\n  display: block;\n  margin-top: 5px;\n}\n\n.membership-form button {\n  width: 100%;\n  padding: 0.8rem;\n  margin-top: 1rem;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.membership-form button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.cancel-btn {\n  background: #dc3545 !important;\n  margin-top: 0.6rem;\n}\n\n/* Stripe card element */\n.stripe-card-element-wrapper {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 12px 14px;\n  background: #fff;\n  box-sizing: border-box;\n  margin-top: 4px;\n  transition: border-color 0.2s;\n}\n\n.stripe-card-element-wrapper:focus-within {\n  border-color: #007bff;\n}\n\n/* Stripe security note */\n.secure-note {\n  font-size: 12px;\n  color: #555;\n  background: #f0fff4;\n  border: 1px solid #c3e6cb;\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n/* ── Sections ── */\n.membership-section {\n  margin-bottom: 3rem;\n}\n\n.section-badge {\n  display: inline-block;\n  background: #007bff;\n  color: #fff;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 4px 14px;\n  border-radius: 20px;\n  margin-bottom: 0.75rem;\n  letter-spacing: 0.05em;\n}\n\n.welfare-badge {\n  background: #00703C;\n}\n\n.section-divider {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 2rem 0;\n  color: #aaa;\n  font-size: 0.9rem;\n}\n\n.section-divider::before,\n.section-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #e0e0e0;\n}\n\n/* ── Plan cards ── */\n.membership-plan-card {\n  border-top: 4px solid #007bff;\n}\n\n.welfare-plan-card {\n  border-top: 4px solid #00703C;\n}\n\n.plan-icon {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n/* ── Welfare options ── */\n.welfare-payment-options {\n  background: #f0f7f0;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  margin: 1rem 0;\n  text-align: left;\n}\n\n.welfare-options-label {\n  font-size: 12px;\n  font-weight: bold;\n  color: #555;\n  margin: 0 0 0.5rem;\n}\n\n.welfare-options-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px 8px;\n  font-size: 13px;\n  color: #444;\n}\n\n.welfare-join-btn {\n  margin-top: 1rem;\n  background: #00703C;\n  color: white;\n  border: none;\n  padding: 0.65rem 1.4rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: bold;\n  width: 100%;\n  transition: background 0.2s;\n}\n\n.welfare-join-btn:hover { background: #005a30; }\n\n.outline-btn {\n  background: transparent !important;\n  border: 2px solid #00703C !important;\n  color: #00703C !important;\n}\n\n.outline-btn:hover {\n  background: #00703C !important;\n  color: #fff !important;\n}\n\n.welfare-cta { margin-top: 0.5rem; }\n\n.welfare-login-note {\n  font-size: 13px;\n  color: #888;\n  margin-bottom: 0.5rem;\n}\n\n.welfare-locked-note {\n  font-size: 13px;\n  color: #856404;\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin-bottom: 0.5rem;\n  text-align: left;\n}\n\n.already-member-note {\n  font-size: 13px;\n  color: #28a745;\n  margin-top: 0.75rem;\n}\n\n.link-text {\n  color: #007bff;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.link-text:hover { color: #0056b3; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
